module.exports = "<p>\r\n  oauth-callback works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/oauth-callback/oauth-callback.component.html
// module id = ./src/app/oauth-callback/oauth-callback.component.html
// module chunks = main